export const feedTankSvgPath: string = `
  M 256 0 C 255.879 0 255.75772 0.012390651 255.63672 0.025390625 C 
  255.44372 0.025390625 255.24964 0.036828149 255.05664 0.048828125 C 
  254.99664 0.060828101 254.93695 0.072265625 254.87695 0.072265625 C 
  253.99495 0.18026541 253.11358 0.39804757 252.26758 0.74804688 C 
  252.00258 0.86904662 251.7367 0.99171898 251.4707 1.1367188 L 251.45703 
  1.1367188 C 251.18003 1.2937184 250.90272 1.4498598 250.63672 1.6308594 C 
  250.62472 1.6308594 250.625 1.6305781 250.625 1.6425781 L 165.88477 58.394531 L 
  159.75977 58.394531 C 154.43277 58.394531 150.0957 62.719604 150.0957 
  68.058594 C 150.0957 73.192584 154.1053 77.3735 159.1543 77.6875 L 
  159.1543 280.89648 C 154.1053 281.21048 150.0957 285.39141 150.0957 
  290.52539 C 150.0957 295.86439 154.43277 300.18945 159.75977 300.18945 L 
  178.90625 300.18945 L 160.06055 492.67188 L 157.75391 492.67188 C 
  152.41491 492.67188 148.08984 496.99694 148.08984 502.33594 C 148.08984 
  507.66292 152.41491 512 157.75391 512 L 168.81836 512 L 168.83008 512 L 
  168.84375 512 L 179.89648 512 C 185.23548 512 189.56055 507.66292 189.56055 
  502.33594 C 189.56055 496.99694 185.23548 492.67187 179.89648 492.67188 L 
  179.47266 492.67188 L 182.86719 458.0625 L 256 417.35352 L 329.54492 
  458.29297 L 332.61133 492.67188 L 332.10547 492.67188 C 326.76647 
  492.67188 322.44141 496.99694 322.44141 502.33594 C 322.44141 507.66292 
  326.76647 512 332.10547 512 L 343.1582 512 L 343.16992 512 L 343.18164 512 L 
  354.24609 512 C 359.58509 512 363.91016 507.66292 363.91016 502.33594 C 363.91016 
  496.99694 359.58509 492.67187 354.24609 492.67188 L 352.01172 492.67188 L 334.82227
  300.18945 L 352.24023 300.18945 C 357.56723 300.18945 361.9043 295.86439 361.9043 
  290.52539 C 361.9043 285.39141 357.8947 281.21048 352.8457 280.89648 L 352.8457 
  77.6875 C 357.8947 77.3735 361.9043 73.192584 361.9043 68.058594 C 361.9043 62.719604 
  357.56723 58.394531 352.24023 58.394531 L 346.11523 58.394531 L 261.375 1.6425781 C 
  261.375 1.6305781 261.36328 1.6308594 261.36328 1.6308594 C 261.11028 1.4618596 260.84441 
  1.305156 260.56641 1.1601562 L 260.5293 1.1230469 C 260.2753 1.0030471 260.03553 0.88243728 
  259.76953 0.7734375 C 259.16553 0.519438 258.53648 0.31435912 257.89648 0.19335938 C 257.88448 
  0.19335938 257.88505 0.1936406 257.87305 0.18164062 C 257.64305 0.1446407 257.40216 0.10993746 
  257.16016 0.0859375 C 257.08716 0.072937526 257.01536 0.060828101 256.94336 0.048828125 C 
  256.76136 0.036828149 256.57944 0.0234375 256.39844 0.0234375 C 256.26544 0.011437524 
  256.133 0 256 0 z M 256 14.027344 L 331.25781 64.435547 L 180.74219 64.435547 L 256 14.027344 z 
  M 256 21.296875 L 200.61328 58.394531 L 311.38672 58.394531 L 256 21.296875 z M 172.44141 71.683594 L 
  339.55664 71.683594 L 339.55664 286.90039 L 172.44141 286.90039 L 172.44141 71.683594 z M 178.48242 
  77.722656 L 178.48242 280.86133 L 189.51172 280.86133 L 189.52344 280.86133 L 324.37305 280.86133 L 
  324.38477 280.86133 L 333.51758 280.86133 L 333.51758 77.722656 L 178.48242 77.722656 z M 192.85547 
  294.14844 L 320.93359 294.14844 L 323.66992 324.75977 L 189.8418 324.75977 L 192.85547 294.14844 z 
  M 198.33008 300.18945 L 196.50586 318.7207 L 317.06445 318.7207 L 315.41016 300.18945 L 198.33008 
  300.18945 z M 194.62109 338.04883 L 318.79297 338.04883 L 320.68945 359.23633 L 256 395.23438 L 
  192.48242 359.87695 L 194.62109 338.04883 z M 322.57227 380.30469 L 327.46484 435.01367 L 
  275.87109 406.30078 L 322.57227 380.30469 z M 190.42969 380.85938 L 236.12891 406.30078 L 
  185.16211 434.66406 L 190.42969 380.85938 z
`;
